export const categoriesData = [
  {
    id: 'platform-intro',
    name: '平台介绍',
    slug: 'platform-intro',
    description: '全面了解jiuyou平台的核心理念、发展历程与服务生态',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20interface%20with%20clean%20minimalist%20design%2C%20warm%20coral%20and%20cream%20color%20accents%2C%20soft%20abstract%20geometric%20shapes%2C%20smooth%20gradients%2C%20friendly%20tech%20aesthetic%2C%20high%20quality%20editorial%20style%2C%20harmonious%20composition%20with%20ample%20negative%20space&width=800&height=500&seq=category-platform-01&orientation=landscape',
    articles: [
      { id: 1, title: 'jiuyou平台核心功能全面解析', slug: 'core-features', summary: '深入了解jiuyou平台提供的全方位服务能力，从智能匹配到数据分析，覆盖用户全旅程。', date: '2026-08-01', readTime: '8分钟' },
      { id: 2, title: '为什么选择jiuyou？五大理由告诉你', slug: 'why-choose-jiuyou', summary: '从安全性、效率、体验、价格、服务五个维度全面解读jiuyou的核心竞争力。', date: '2026-07-28', readTime: '6分钟' },
      { id: 3, title: 'jiuyou平台架构与技术优势', slug: 'tech-advantage', summary: '揭秘jiuyou背后的技术架构，分布式系统与智能算法的完美结合。', date: '2026-07-20', readTime: '10分钟' },
    ],
  },
  {
    id: 'user-guide',
    name: '使用教程',
    slug: 'user-guide',
    description: '从注册到高阶使用，手把手教你玩转jiuyou平台',
    icon: 'ri-book-open-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20tutorial%20and%20learning%20scene%20with%20laptop%20displaying%20friendly%20interface%2C%20warm%20lighting%2C%20minimalist%20desk%20setup%2C%20soft%20cream%20and%20warm%20neutral%20background%2C%20educational%20atmosphere%2C%20editorial%20photography%20style%2C%20professional%20yet%20approachable&width=800&height=500&seq=category-guide-02&orientation=landscape',
    articles: [
      { id: 4, title: 'jiuyou新用户注册与快速上手指南', slug: 'quick-start', summary: '只需三步，快速完成jiuyou账号注册，开启您的全新体验之旅。', date: '2026-08-05', readTime: '5分钟' },
      { id: 5, title: 'jiuyou高级功能使用技巧大全', slug: 'advanced-tips', summary: '解锁jiuyou的隐藏技能，让您的工作效率提升200%。', date: '2026-07-25', readTime: '12分钟' },
      { id: 6, title: 'jiuyou移动端使用全攻略', slug: 'mobile-guide', summary: '随时随地使用jiuyou，移动端功能与桌面端无缝衔接的完整指南。', date: '2026-07-18', readTime: '7分钟' },
    ],
  },
  {
    id: 'promotions',
    name: '优惠活动',
    slug: 'promotions',
    description: '最新优惠、限时福利，不错过每一个省钱机会',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20celebration%20and%20promotional%20scene%20with%20festive%20elements%2C%20golden%20and%20coral%20accents%2C%20soft%20cream%20background%2C%20elegant%20gift%20boxes%20and%20ribbons%2C%20warm%20atmospheric%20lighting%2C%20premium%20lifestyle%20photography%2C%20joyful%20and%20inviting%20mood&width=800&height=500&seq=category-promo-03&orientation=landscape',
    articles: [
      { id: 7, title: 'jiuyou新用户专享：首单立减50%优惠', slug: 'new-user-offer', summary: '新注册用户可享受首笔服务五折优惠，数量有限先到先得。', date: '2026-08-08', readTime: '3分钟' },
      { id: 8, title: 'jiuyou会员日：每月18号惊喜不断', slug: 'member-day', summary: '每月18日jiuyou会员专属福利大放送，折扣、积分、礼品等你来拿。', date: '2026-08-02', readTime: '4分钟' },
      { id: 9, title: '邀请好友注册jiuyou，双方各得100元奖励', slug: 'referral-program', summary: 'jiuyou推荐有礼活动火热进行中，邀请越多奖励越多。', date: '2026-07-30', readTime: '5分钟' },
    ],
  },
  {
    id: 'reviews',
    name: '用户评价',
    slug: 'reviews',
    description: '真实用户分享，口碑见证jiuyou品质',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20community%20and%20testimonial%20scene%2C%20happy%20diverse%20people%20interacting%20with%20digital%20devices%2C%20soft%20cream%20and%20warm%20neutral%20tones%2C%20friendly%20atmosphere%2C%20natural%20light%2C%20authentic%20lifestyle%20photography%2C%20genuine%20smiles%20and%20positive%20energy&width=800&height=500&seq=category-review-04&orientation=landscape',
    articles: [
      { id: 10, title: '来自10万+用户的真实声音', slug: 'user-feedback', summary: '汇聚超过十万名jiuyou用户的真实使用体验与改进建议。', date: '2026-08-06', readTime: '8分钟' },
      { id: 11, title: '行业专家眼中的jiuyou', slug: 'expert-review', summary: '多位行业资深专家深度评测jiuyou平台，听听他们怎么说。', date: '2026-07-22', readTime: '10分钟' },
      { id: 12, title: 'jiuyou vs 竞品：用户真实对比体验', slug: 'comparison', summary: '真实用户分享jiuyou与其他平台的横向对比，用数据说话。', date: '2026-07-15', readTime: '9分钟' },
    ],
  },
];

export const allArticles = categoriesData.flatMap(cat =>
  cat.articles.map(article => ({ ...article, categoryId: cat.id, categoryName: cat.name, categorySlug: cat.slug }))
);